<emm-management-layout>
  <emm-progress-bar [isLoading$]="centerLoading$" progress-bar-center></emm-progress-bar>
  <emm-search-filter
    [addDialog]="false"
    [attr.data-testid]="'location_set_types_search_bar'"
    [displaySearchWithOptions]="true"
    [fields]="fields$ | async"
    [isAdminOrAuthor]="this.isAdmin || this.isAuthor"
    [isSuperAdmin]="this.isSuperAdmin"
    [filteredOptions]="filteredOptions$"
    layout-center-header
    [searchLabel]="'Type location name or number'"
    (filter)="onFilter($event)"
    (selected)="onSelectingLocation($event)"
  ></emm-search-filter>
  @if (showResult) {
    <main layout-center-content class="assignment-container">
      <div>
        <p>Effective Date: {{ effectiveDate | date: 'MM/dd/yyyy' }}</p>
      </div>
      <div id="assignments">
        <div>
          <p>English - {{ isEnglish }}</p>
        </div>
        <div>
          <p>Spanish - {{ isSpanish }}</p>
        </div>
      </div>
    </main>
  }
  <emm-language-assignments-form
    layout-right-content
    [showResult]="this.showResult"
    [english]="this.isEnglish"
    [spanish]="this.isSpanish"
    [date]="this.effectiveDate"
    [location]="this.storeNumber"
    [isSuperAdmin]="this.isSuperAdmin"
    [isAdmin]="this.isAdmin"
    (languageAssignmentSaved)="ngOnChanges($event)"
    >
  </emm-language-assignments-form>
</emm-management-layout>
